import React, { useState } from 'react';
import { View } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Fields, defaultValues, prepareInput } from 'app/src/elements/forms';
import { Button } from 'app/src/elements/buttons';
import { Loading } from 'app/src/elements/DataState';
import { Title } from 'app/src/styles';
import { useNavigate } from 'app/src/utils/routing';

import { CREATE_PROVIDER } from './queries';

import { CLIENTS } from 'app/src/components/Clients/queries';

export const FIELDS = {
  clientId: {
    label: 'Client',
    type: 'hidden',
    rules: { required: true },
  },
  name: {
    label: 'Name',
    rules: { required: true },
  },
  emoji: {
    label: 'Emoji',
    type: 'emoji',
  },
  providerType: {
    label: 'Provider Type',
  },
  address: {
    label: 'Address',
  },
  phoneNumber: {
    label: 'Phone Number',
  },
  startOn: {
    label: 'Start Date',
    type: 'date',
    blank: 'null',
  },
  endOn: {
    label: 'End Date',
    type: 'date',
    blank: 'null',
  },
  notes: {
    label: 'Notes',
    type: 'textarea',
  },
};

const NewProvider = ({ onCreated, clientId }) => {
  const [formStatus, setFormStatus] = useState();
  const navigate = useNavigate();

  const { control, handleSubmit, formState: { errors }, watch } = useForm({
    defaultValues: defaultValues({
      fields: FIELDS,
      resource: { client: { id: clientId } }
    })
  });

  const { data: selects } = useQuery(CLIENTS, {
    variables: { limit: 100000, offset: 'MA==', options: {} }
  });

  const [createProvider] = useMutation(CREATE_PROVIDER, {
    onCompleted: data => {
      if (onCreated) {
        onCreated(data.createProvider.provider);
      } else {
        navigate('/providers');
      }
    }
  });

  const onSubmit = input => {
    setFormStatus('submitting');
    createProvider({ variables: { input: prepareInput(input, FIELDS) } });
  };

  const fields = { ...FIELDS };

  if (selects) {
    fields.clientId = {
      ...fields.clientId,
      type: 'select',
      select: [
        { value: '', label: '--Choose--' },
        ...selects.clients.edges
          .map(edge => ({ value: edge.node.id, label: edge.node.name }))
      ],
    };
  }

  return (
    <View>
      <Title>Add Provider</Title>

      <Fields
        fields={fields}
        control={control}
        errors={errors}
      />

      {'submitting' === formStatus ? (
        <Loading />
      ) : (
        <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
      )}
    </View>
  );
};

export default NewProvider;
